import {IContract} from './contract.types';

export interface IDashboardDetail {
  contractId: number;
  district: string;
  statuses: {
    status: string;
    count: number;
  }[];
}

export interface IDashboardHeader<T extends 'NUMBER' | 'STRING'> {
  caption: string;
  hierachy: null | number;
  level: null | number;
  parant: null | number;
  type: T;
}

export interface IDashboardDTO {
  contracts: {
    contract: IContract;
    details: IDashboardDetail[];
  }[];
  headers: {
    contract: IDashboardHeader<'STRING'>;
    count: IDashboardHeader<'NUMBER'>;
    district: IDashboardHeader<'STRING'>;
    status: IDashboardHeader<'STRING'>;
  };
  totals: IDashboardDetail;
}

export interface IDashboardPayload {
  serviceType?: string;
  status?: string;
  period?: string;
  from?: string;
  to?: string;
  isArchive?: boolean;
}

export enum DashboardTypes {
  //  Движение заявок
  REQUESTS_MOVE = 'requestsMove',
  // Статус заявок
  REQUESTS_STATUSES = 'requestsStatuses',
}
